<template>
  <form
    role="form"
    method="POST"
    action="/register"
    class="onboarding-form"
    @submit.prevent="submit"
    novalidate
  >
    <div class="onboarding-navbar">
    </div>

    <div class="tab-content">

      <div class="onboarding-tab active">
        <header>
          <h2 class="tab-title no-ml">{{ __('Step 2: Registration') }}</h2>
        </header>

        <div class="tab-inputgroup">
          <FormInputTypeAvatarImageSelect name="avatar" />

          <form-input-type-text
            name="name"
            :label="__('First name')"
            :errors="errors.name"
            :value="pendingPatient.name"
            margin-bottom-double
            required
          ></form-input-type-text>

          <form-input-type-text
            name="surname"
            :label="__('Last name')"
            :errors="errors.surname"
            :value="pendingPatient.surname"
            margin-bottom-double
            required
          ></form-input-type-text>

          <form-input-type-phone-number
            name="phone"
            :label="__('Phone number')"
            :errors="errors.phone"
            :value="pendingPatient.phone"
            phoneCountry="CZ"
            :note="__('We need a phone number as a second option to contact your dietitian.')"
            margin-bottom-double
            required
          ></form-input-type-phone-number>

          <form-input-type-email
            name="email"
            :label="__('E-mail')"
            :errors="errors.email"
            :value="pendingPatient.email"
            margin-bottom-double
            required
          ></form-input-type-email>

          <form-input-type-password 
            name="password"
            :label="__('Password')"
            :errors="errors.password"
            :note="__('The password must contain at least 10 characters and at least one upper and one lower case letter.')"
            margin-bottom-double
            required
          ></form-input-type-password>

          <div :class="['input-wrapper wrapper-checkbox']">
            <input
              type="checkbox"
              class="input-checkbox"
              id="privacy"
              name="privacy"
              required=""
            />
            <label
              class="input-label label-checkbox"
              for="privacy"
              v-html="__(`* Souhlasím se <a href='/obchodni-podminky' target='_blank'>Všeobecnými obchodními podmínkami</a> a potvrzuji, že jsem si přečetl <a href='/ochrana-osobnich-udaju' target='_blank'>Informace o ochraně osobních údajů</a>, které beru na vědomí.`)"
            >
            </label>
            <template v-if="errors.privacy">
              <span class="help-block">
                <strong>{{ errors.privacy[0] }}</strong>
              </span>
            </template>
          </div>

          <div :class="['input-wrapper wrapper-checkbox']">
            <input
              type="checkbox"
              class="input-checkbox"
              id="personal_data"
              name="personal_data"
              required=""
            />
            <label class="input-label label-checkbox" for="personal_data">
              {{ __("* I consent to the processing of my personal health data for the purpose of using the app. I can withdraw this consent at any time.") }}
              <a class="label-icon" data-target="#modal-personal-data" data-toggle="modal" data-dismiss="modal">
                <figure><svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9 17.8125c4.6406 0 8.4375-3.7969 8.4375-8.44531 0-4.64844-3.7969-8.445315-8.44531-8.445315C4.35156.921875.554688 4.71875.554688 9.36719.554688 14.0156 4.35156 17.8125 9 17.8125zm.03125-10.64062c-.67187 0-1.23437-.57032-1.23437-1.22657 0-.70312.5625-1.25 1.23437-1.25s1.23435.54688 1.23435 1.25c0 .65625-.56248 1.22657-1.23435 1.22657zM7.57812 13.4375c-.46093 0-.82031-.3203-.82031-.7969 0-.4375.35938-.789.82031-.789h.80469V9.67188h-.65625c-.45312 0-.8125-.32813-.8125-.79688 0-.44531.35938-.78906.8125-.78906h1.54688c.59375 0 .90626.39844.90626 1.03125v2.73441h.5234c.4531 0 .8125.3515.8125.789 0 .4766-.3594.7969-.8125.7969H7.57812z" fill="url(#paint0_linear)"/> <defs> <linearGradient id="paint0_linear" x1="-4.76456" y1="5.57051" x2="10.8375" y2="26.1795" gradientUnits="userSpaceOnUse"> <stop stop-color="#8B65E6"/> <stop offset="1" stop-color="#5937B7"/> </linearGradient> </defs></svg></figure>
              </a>
            </label>
            <template v-if="errors.personal_data">
              <span class="help-block">
                <strong>{{ errors.personal_data[0] }}</strong>
              </span>
            </template>
          </div>

          <div :class="['input-wrapper wrapper-checkbox']">
            <input
              type="checkbox"
              class="input-checkbox"
              id="marketing_agreement"
              name="marketing_agreement"
              value="1"
              required=""
            />
            <label class="input-label label-checkbox" for="marketing_agreement">{{ __("I agree to receive updates, news and other useful information.") }}</label>
            <template v-if="errors.marketing_agreement">
              <span class="help-block">
                <strong>{{ errors.marketing_agreement[0] }}</strong>
              </span>
            </template>
          </div>

          <slot></slot>
        </div>
      </div>
    </div>

    <ul class="onboarding-pager">
      <li class="next">
        <v-button :label="__('Create an account')" type="submit" position="center" size="lg" class="btn-next" />
      </li>
    </ul>
  </form>
</template>

<script>
export default {
  props: {
    pendingPatient: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      errors: {},
      previewImg: null,
    }
  },
  methods: {
    submit() {
      const data = new FormData(this.$el)

      axios
        .post('register', data)
        .then(() => window.location.replace('/overeni-telefonniho-cisla'))
        .catch((e) => {
          this.errors = e.response.data.errors
        })
    }
  }
}
</script>
